// extracted by css-extract-rspack-plugin
export default {"root":"CvY6G8"};